import { Component } from '@angular/core';
import { RepairDocketStore } from '../../repair-docket.store';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { MatButton } from '@angular/material/button';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-edit-repair-docket-settings',
    templateUrl: './edit-repairs-docket-settings.component.html',
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatRadioGroup, MatRadioButton, MatDialogActions, MatButton, MatDialogClose]
})
export class EditRepairsDocketSettingsComponent {
  form = new FormGroup({
    purchase_order: new FormControl<string>(''),
    account: new FormControl<boolean>(false)
  });

  constructor(
    private store: RepairDocketStore,
    private dialog: MatDialogRef<EditRepairsDocketSettingsComponent>
  ) {
    this.store.docket$
      .pipe(take(1))
      .subscribe(({ purchase_order, account }) => {
        this.form.patchValue({
          purchase_order,
          account
        });
      });
  }

  save() {
    this.store.updateDocket({
      value: this.form.value,
      onComplete: () => this.dialog.close()
    });
  }
}
